import * as React from 'react';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';

export const RatingHelper = {
    convertToStars: (rating: number, id: string) => {
        let stars:JSX.Element[] = [];
        //const { classes } = this.props;
        if (rating >= 1) {
            stars.push(<StarIcon key={`1${id}`} style={{ width: 13, height: 13 }} />);
        }
        if (rating >= 2) {
            stars.push(<StarIcon key={`2${id}`} style={{ width: 13, height: 13 }} />);
        }
        if (rating >= 3) {
            stars.push(<StarIcon key={`3${id}`} style={{ width: 13, height: 13 }} />);
        }
        if (rating >= 4) {
            stars.push(<StarIcon key={`4${id}`} style={{ width: 13, height: 13 }} />);
        }
        let ratingStr = rating.toString();
        if (ratingStr.substring(ratingStr.length, ratingStr.length - 1) === '5') {
            stars.push(<StarHalfIcon key={`half${id}`} style={{ width: 13, height: 13 }} />);
        }

        return stars;
    }
};
export default RatingHelper;